<div *ngIf="messages.length">
	<p *ngFor="let message of messages">{{ message }}</p>
</div>
